<template>
  <footer class="site-footer">
    <div class="footer-container">
      <div class="footer-top">
        <div
          class="footer-col"
          :class="{ 'mobile-active': footerDropdowns.product }"
        >
          <h3 @click="toggleFooterDropdown('product')">
            ຜະລິດຕະພັນ
            <span class="footer-arrow"></span>
          </h3>
          <ul class="footer-list">
            <li>
              <router-link to="/products/life">ປະກັນຊີວິດ</router-link>
            </li>
            <li>
              <router-link to="/products/health">ສັນຍາເພີ່ມເຕີມ ປະກັນສຸຂະພາບ</router-link>
            </li>
            <li>
              <router-link to="/products/accident">ປະກັນອຸປະຕິເຫດ</router-link>
            </li>
          </ul>
        </div>


        <div
          class="footer-col"
          :class="{ 'mobile-active': footerDropdowns.news }"
        >
          <h3 @click="toggleFooterDropdown('news')">
            ຂ່າວສານ
            <span class="footer-arrow"></span>
          </h3>
          <ul class="footer-list">
            <li>
              <router-link to="/news">ຂ່າວສານ ໂຊກໄຊ ປະກັນຊີວິດ</router-link>
            </li>
            <li>
              <router-link to="/news">ຂ່າວສານ CSR</router-link>
            </li>
          </ul>
        </div>


        <div
          class="footer-col"
          :class="{ 'mobile-active': footerDropdowns.career }"
        >
          <h3 @click="toggleFooterDropdown('career')">
            ຮ່ວມງານກັບພວກເຮົາ
            <span class="footer-arrow"></span>
          </h3>
          <ul class="footer-list">
            <li><router-link to="/careers/jobs">ຕຳແໜ່ງງານວ່າງ</router-link></li>
            <li>
              <router-link to="/careers/agent">ສະໝັກເປັນຕົວແທນ</router-link>
            </li>
          </ul>
        </div>


        <div class="footer-col">
          <ul>
            <li>
              <h3><router-link to="/articles">ບົດຄວາມທີ່ໜ້າສົນໃຈ</router-link></h3>
            </li>
            <li>
              <h3><router-link to="/about">ກ່ຽວກັບພວກເຮົາ</router-link></h3>
            </li>
            <li>
              <h3><router-link to="/contact">ຕິດຕໍ່ພວກເຮົາ</router-link></h3>
            </li>
          </ul>
        </div>
      </div>

      <div class="footer-divider"></div>
      <div class="footer-address">
        <div class="address-content">
          <img
            src="@/assets/building-thumb.png"
            alt="Building"
            class="building-img"
          />
          <p>{{ CompanyAddress }}</p>
        </div>
      </div>

      <div class="footer-divider"></div>

      <div class="footer-contact-social">
        <div class="contact-box">
          <h4>ເບີໂທຕິດຕໍ່</h4>
          <div class="icon-text">
            <img
              src="@/assets/whatsapp-icon.png"
              alt="WhatsApp"
              class="social-icon"
            />
            <span
              v-for="(phone, index) in phoneNumbers"
              :key="index"
              :href="`tel:${phone.replace(/\s/g, '')}`"
              >{{ phone }}
            </span>
            <!--<span>020 5959 5242 &nbsp;&nbsp; 020 5959 5442</span> -->
          </div>
        </div>

        <div class="contact-box">
          <h4>Social media</h4>
          <div class="icon-text">
            <img
              src="@/assets/facebook-icon.png"
              alt="Facebook"
              class="social-icon"
            />
            <a href="https://www.facebook.com/Sokxaylifeinsurance?locale=th_TH" target="_blank">ບໍລິສັດ ໂຊກໄຊ ປະກັນຊີວິດ</a>
          </div>
        </div>
      </div>

      <div class="footer-divider"></div>

      <div class="footer-bottom">
        <div class="bottom-left">
          <img src="@/assets/logo2.jpg" alt="Sokxay Logo" class="footer-logo" />
          <span>© 2025 ບໍລິສັດ ໂຊກໄຊ ປະກັນຊີວິດ ຈຳກັດຜູ້ດຽວ</span>
        </div>
        <div class="bottom-right">
          <a href="#">ເງື່ອນໄຂການໃຊ້ບໍລິການ</a>
          <a href="#">ນະໂຍບາຍຂໍ້ມູນຄວາມເປັນສ່ວນຕົວ</a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "cFooter",
  // ถ้าต้องการใส่ Logic เพิ่มเติม ใส่ที่นี่
  data() {
    return {
      // ⭐️ เพิ่ม state สำหรับ Dropdown
      footerDropdowns: {
        product: false,
        career: false,
        news: false,
      },
      phoneNumbers: ["020 5959 5242", "020 5959 5442"],
      companyLogo: "@/assets/logo2.jpg",
      CompanyAddress:
        "ອາຄານ ໂຊກໄຊ ກຣຸບ ຊັ້ນ 2, ເຮືອນ ເລກທີ 12, ຖະໜົນ ກຳແພງເມືອງ, ບ້ານ ທາດຫຼວງກາງ, ເມືອງ ໄຊເສດຖາ, ນະຄອນຫລວງວຽງຈັນ, ສປປ ລາວ",
      CompanyImage: "@/assets/building-thumb.png",
    };
  },
  methods: {
    // ⭐️ เพิ่มฟังก์ชัน Toggle
    toggleFooterDropdown(section) {
      // เช็คหน้าจอ ถ้าเป็นมือถือถึงจะทำงาน
      if (window.innerWidth <= 768) {
        this.footerDropdowns[section] = !this.footerDropdowns[section];
      }
    },
  },
};
</script>

<style scoped>
/* ===== BASE STYLES ===== */
.site-footer {
  background-color: #323d47; /* สีพื้นหลังตามภาพ */
  color: #ffffff;
  font-family: "Noto Sans Lao", sans-serif;
  padding: 40px 0 20px 0;
  width: 100%;
}

.footer-container {
  max-width: 1200px; /* จำกัดความกว้างเนื้อหา */
  margin: 0 auto;
  padding: 0 20px;
}

/* เส้นขีดคั่นแนวนอน */
.footer-divider {
  border-top: 1px solid rgb(255, 255, 255); /* สีเส้นจางๆ */
  margin: 6px 0;
  width: 100%;
}

a {
  text-decoration: none;
  color: #d1d5db;
  transition: color 0.5s ease;
}

a:hover {
  color: #ffffff;
}

/* ===== 1. TOP SECTION (LINKS) ===== */
.footer-top {
  display: flex;
  justify-content: space-between;
  gap: 24px;
  flex-wrap: wrap;
}

.footer-col {
  flex: 1;
  min-width: 250px; /* ขนาดต่ำสุดก่อนจะย่อ */
}

.footer-col h3 {
  font-size: 18px;
  margin: 6px 0;
  color: #e0e0e0;
  font-weight: 600;
}

.footer-col ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.footer-col ul li {
  border-bottom: 1px solid #404b55; /* เส้นคั่นระหว่างเมนู */
}
.footer-col ul li h3 {
  font-weight: 600;
}
.footer-col ul li:last-child {
  border-bottom: none;
}

.footer-col ul li a {
  display: block;
  margin: 6px 0;
  font-size: 16px;
}

/* ===== 2. ADDRESS SECTION ===== */
.footer-address {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.address-content {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 0;
}

.building-img {
  width: 80px; /* ขนาดรูปตึก */
  height: 60px;
  object-fit: cover;
  border-radius: 2px;
  border: 1px solid #555;
}

.address-content p {
  font-size: 16px;
  line-height: 1.5;
  color: #d1d5db;
  margin: 0;
}

/* ===== 3. CONTACT & SOCIAL SECTION ===== */
.footer-contact-social {
  display: flex;
  justify-content: center; /* จัดกึ่งกลางตามภาพ */
  gap: 32px; /* ระยะห่างระหว่าง เบอร์โทร กับ Facebook */
  text-align: center;
  padding: 16px 0;
}

.contact-box h4 {
  font-size: 18px;
  margin-bottom: 4px;
  color: #fff;
}

.icon-text {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  font-size: 18px;
}

.social-icon {
  width: 32px;
  height: 32px;
}

/* ===== 4. BOTTOM SECTION ===== */
.footer-bottom {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 16px;
  font-size: 14px;
  color: #9ca3af;
  gap: 48px;
}

.bottom-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.footer-logo {
  height: 40px; /* ปรับขนาดโลโก้ท้ายเว็บ */
  width: auto;
}

.bottom-right {
  display: flex;
  gap: 12px;
}

.bottom-right a {
  font-size: 14px;
  color: #9ca3af;
}
/* ⭐️ ซ่อนลูกศรใน Desktop */
.footer-arrow {
  display: none;
}
/* =========================================
   RESPONSIVE STYLES
   ========================================= */

/* ===== TABLET (iPad) ===== */
@media (max-width: 992px) {
  .footer-contact-social {
    gap: 40px;
  }

  .icon-text {
    font-size: 16px;
  }
}

/* ===== MOBILE (Smartphones) ===== */
@media (max-width: 768px) {
  /* 1. Top Section: Stack columns */
  .footer-top {
    flex-direction: column;
    gap: 0px;
  }

  .footer-col {
    width: 100%;
    border-bottom: 1px solid #4a555e; /* เส้นคั่นระหว่างหัวข้อ */
  }
  /* ไม่ใส่เส้นคั่นอันสุดท้าย */
  .footer-col:last-child {
    border-bottom: none;
  }
  /* 2. Address: Stack image and text */
  .address-content {
    flex-direction: column;
    text-align: center;
  }

  .building-img {
    width: 80px;
    height: auto;
  }
  /* ⭐️ ปรับแต่งหัวข้อ h3 ให้คลิกได้ และมีลูกศร */
  .footer-col h3 {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 6px 0;
    margin: 0;
    cursor: pointer; /* เมาส์รูปนิ้ว */
    font-size: 18px;
  }
  /* ⭐️ แสดงลูกศรในมือถือ */
  .footer-arrow {
    display: block;
    width: 12px;
    height: 12px;
    border-right: 2px solid #ffffff;
    border-bottom: 2px solid #ffffff;
    transform: rotate(-45deg); /* ทำเป็นรูปลูกศรชี้ลง */
    transition: transform 0.5s ease;
    margin-right: 10px;
  }
  /* ⭐️ แสดงรายการเมนูเมื่อมี class mobile-active */
  .mobile-active .footer-list {
    display: block;
    animation: fadeIn 0.5s ease;
  }
  /* ⭐️ ซ่อนรายการเมนู (ul) โดย default ในมือถือ */
  .footer-list {
    display: none;
    padding-bottom: 15px;
    padding-left: 10px; /* ย่อหน้าเมนูย่อยนิดหน่อย */
  }
  /* ⭐️ หมุนลูกศรเมื่อเปิด */
  .mobile-active .footer-arrow {
    transform: rotate(45deg); /* หมุนกลับขึ้น */
  }
  .footer-list-static {
    display: block;
    padding: 15px 0;
  }
  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(-5px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  /* 3. Contact: Stack vertically */
  .footer-contact-social {
    flex-direction: column;
    gap: 0px;
  }

  /* 4. Bottom: Stack vertically */
  .footer-bottom {
    flex-direction: column;
    gap: 16px;
    text-align: center;
  }

  .bottom-left {
    flex-direction: column;
    gap: 4px;
  }

  .bottom-right {
    flex-direction: column;
    gap: 4px;
  }
}
</style>